import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "duration", "reset"];

  showReset() {
    if (this.hasResetTarget) {
      this.resetTarget.classList.remove("no-show");
    }
  }

  resetSelect() {
    if (this.hasSelectTarget) {
      $(this.selectTarget).dropdown("clear");
    }
    if (this.hasDurationTarget) {
      $(this.durationTarget).dropdown("clear");
    }
  }

  setDuration(event) {
    const selection = event.target;
    if (!selection.parentNode.parentNode.classList.contains("poll")) {
      return;
    }
    const value = selection.dataset.value;
    if (value === "none") {
      this.resetSelect();
      return;
    }

    if (!this.hasSelectTarget) {
      return;
    }

    const options = Array.from(this.selectTarget.options);
    const option = options.find((e) => e.value === value);
    const duration = option?.dataset.duration;

    if (duration && this.hasDurationTarget) {
      $(this.durationTarget).dropdown("set selected", duration);
    }
  }
}
